import React, { useEffect } from 'react';

const Alert = ({ type = 'success', message, onClose, autoClose = true, duration = 5000 }) => {
  useEffect(() => {
    if (autoClose && onClose) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      
      return () => clearTimeout(timer);
    }
  }, [autoClose, duration, onClose]);

  const alertStyles = {
    success: {
      bg: 'bg-purple-50',
      border: 'border-purple-500',
      text: 'text-purple-800',
      icon: 'fa-check-circle',
      iconColor: 'text-purple-600',
      progressBar: 'bg-purple-600'
    },
    error: {
      bg: 'bg-red-50',
      border: 'border-red-500',
      text: 'text-red-800',
      icon: 'fa-exclamation-circle',
      iconColor: 'text-red-600',
      progressBar: 'bg-red-600'
    },
    warning: {
      bg: 'bg-orange-50',
      border: 'border-orange-500',
      text: 'text-orange-800',
      icon: 'fa-exclamation-triangle',
      iconColor: 'text-orange-600',
      progressBar: 'bg-orange-600'
    },
    info: {
      bg: 'bg-purple-50',
      border: 'border-purple-400',
      text: 'text-purple-800',
      icon: 'fa-info-circle',
      iconColor: 'text-purple-500',
      progressBar: 'bg-purple-500'
    }
  };

  const style = alertStyles[type] || alertStyles.success;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center animate-fadeIn">
      {/* Overlay de fondo */}
      <div 
        className="absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm"
        onClick={onClose}
      ></div>
      
      {/* Alert Card */}
      <div className={`${style.bg} ${style.border} border-l-4 rounded-xl shadow-2xl p-6 relative overflow-hidden max-w-md w-full mx-4 animate-scaleIn z-10`}>
        <div className="flex items-start">
          <div className={`flex-shrink-0 ${style.iconColor}`}>
            <i className={`fas ${style.icon} text-3xl`}></i>
          </div>
          <div className="ml-4 flex-1">
            <p className={`${style.text} font-medium leading-relaxed text-base`}>
              {message}
            </p>
          </div>
          {onClose && (
            <button
              onClick={onClose}
              className={`flex-shrink-0 ml-4 ${style.iconColor} hover:opacity-70 transition-opacity duration-200`}
              aria-label="Cerrar"
            >
              <i className="fas fa-times text-xl"></i>
            </button>
          )}
        </div>
        
        {/* Progress bar for auto-close */}
        {autoClose && (
          <div className="absolute bottom-0 left-0 right-0 h-1 bg-gray-200">
            <div 
              className={`h-full ${style.progressBar} animate-shrink`}
              style={{ animationDuration: `${duration}ms` }}
            ></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Alert;

